'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('oddModule')
    .factory('oddService', ['$http', '$q', function ($http, $q) {
        var baseUrl = environment.apiUrl + '/Pilot/api/ODD/BusinessUnit';

        return {
            // Available Business Units
            getAvailableBusinessUnits: function () {
                return $http
                        .get(baseUrl)
                        .then(function (response) { return response.data; })
            },

            // Get Business Unit
            getBusinessUnit: function (businesUnitCode) {
                return $http
                        .get(baseUrl + '/' + businesUnitCode)
                        .then(function (response) {
                            if (response.error) {
                                return $q.reject(response);
                            } else {
                                return response.data;
                            }
                        })
           },

            // Get Business Unit with progress status
            getBusinessUnitWithProgressStatus: function (businesUnitCode) {
                return $http
                        .get(baseUrl + '/' + businesUnitCode + '/ProgressStatus')
                        .then(function (response) {
                            if (response.error) {
                                return $q.reject(response);
                            } else {
                                return response.data;
                            }
                        })
            },

            // Get Business Unit with progress
            getBusinessUnitWithProgress: function (businesUnitCode) {
                return $http
                        .get(baseUrl + '/' + businesUnitCode + '/Progress')
                        .then(function (response) {
                            if (response.error) {
                                return $q.reject(response);
                            } else {
                                return response.data;
                            }
                        })
            },

            // === External Parties ===

            // Create External Party
            createExternalParty: function (businessUnitID, externalParty) {
                return $http
                    .post(baseUrl + '/' + businessUnitID + '/ExternalParty', externalParty)
                    .then(function (response) { return response.data; })
            },

            // Update External Party
            updateExternalParty: function (businessUnitID, externalParty) {
                return $http
                    .put(baseUrl + '/' + businessUnitID + '/ExternalParty/' + externalParty.ODDExternalPartyID, externalParty)
                    .then(function (response) { return response.data; })
            }
        };
    }]);
